import React from "react";
import { AppSettings } from "../../config/app-settings.js";
import axios from "axios";
import Preloader from "../../components/custom/preLoader.js";
import showErrorToast, { showSuccessToast } from "../../components/toast/toast.js";
import { setAuthTokens } from "../../components/content/axiosConfig.js";

class Login extends React.Component {
  static contextType = AppSettings;

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { loading: false };
  }

  componentDidMount() {
    this.context.handleSetAppSidebarNone(true);
    this.context.handleSetAppHeaderNone(true);
    this.context.handleSetAppContentClass("p-0");
  }

  componentWillUnmount() {
    this.context.handleSetAppSidebarNone(false);
    this.context.handleSetAppHeaderNone(false);
    this.context.handleSetAppContentClass("");
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setState({ loading: true });
    const email = event.target.emailAddress.value;
    const password = event.target.password.value;

    try {
      let API_URL = "";
      if (process.env.REACT_APP_Environment === "development")
        API_URL = process.env.REACT_APP_API_URL;
      else API_URL = process.env.REACT_APP_API_URL_Production;

      const response = await axios.post(`${API_URL}api/SuperUser/Login`, {
        Email: email,
        Password: password,
      });

      const { token, refreshToken, User } = response.data;
      const userData = {
        ...User,
        isSuperUser: true,
        FullName: User.FullName,
        Email: User.Email,
      };
      setAuthTokens(token, refreshToken || null, userData);
      showSuccessToast("Login successful");
      window.location.href = "/pond";
    } catch (error) {
      this.setState({ loading: false });
      const errorMessage = error.response?.data?.message || "An error occurred.";
      showErrorToast(errorMessage);
    }
  }

  render() {
    const { loading } = this.state;
    return loading ? (
      <Preloader />
    ) : (
      <div className="login login-with-news-feed">
        <div className="news-feed">
          <div
            className="news-image"
            style={{
              backgroundImage: "url(/assets/img/login-bg/login-bg-11.jpg)",
            }}
          ></div>
          <div className="news-caption">
            <h4 className="caption-title">
              <b>SSF</b> Fishing
            </h4>
            <p>
              SSF Fishing is a leading platform in the fisheries industry, offering a comprehensive system to efficiently manage and optimize your fisheries operations
            </p>
          </div>
        </div>
        <div className="login-container">
          <div className="login-header mb-30px">
            <div className="brand">
              <div className="d-flex align-items-center">
                <span className="logo"></span>
                <b>SSF</b> Fishing
              </div>
              <small>Super User Panel</small>
            </div>
            <div className="icon">
              <i className="fa fa-sign-in-alt"></i>
            </div>
          </div>
          <div className="login-content">
            <form onSubmit={this.handleSubmit} className="fs-13px">
              <div className="form-floating mb-15px">
                <input
                  type="email"
                  className="form-control h-45px fs-13px"
                  placeholder="Email Address"
                  id="emailAddress"
                  name="emailAddress"
                  required
                />
                <label htmlFor="emailAddress" className="d-flex align-items-center fs-13px text-gray-600">
                  Email
                </label>
              </div>
              <div className="form-floating mb-15px">
                <input
                  type="password"
                  className="form-control h-45px fs-13px"
                  placeholder="Password"
                  id="password"
                  name="password"
                  required
                />
                <label htmlFor="password" className="d-flex align-items-center fs-13px text-gray-600">
                  Password
                </label>
              </div>
              <div className="mb-15px">
                <button type="submit" className="btn btn-success d-block h-45px w-100 btn-lg fs-14px">
                  Sign me in
                </button>
              </div>
              <hr className="bg-gray-600 opacity-2" />
              <div className="text-gray-600 text-center text-gray-500-darker mb-0">
                © SSF Fishing. All Rights Reserved
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
